/**  course actions constants */
export const SET_LIST_COURSE = 'course/SET_LIST_COURSE';